import { useState } from 'react';
import { Link } from 'react-router-dom';

const faqData = [
  {
    question: 'Was ist ein OOPBUY Spreadsheet?',
    answer: 'Ein OOPBUY Spreadsheet ist eine strukturierte Produkt\u00fcbersicht, die es K\u00e4ufern erm\u00f6glicht, tausende Produkte aus verschiedenen Kategorien schnell zu finden, Preise zu vergleichen und fundierte Kaufentscheidungen zu treffen. Es ist speziell f\u00fcr den deutschsprachigen Markt optimiert.',
  },
  {
    question: 'Wie funktioniert OOPBUY?',
    answer: 'OOPBUY funktioniert als Vermittlungsplattform, die Produkte von verschiedenen Quellen in einer \u00fcbersichtlichen Tabelle zusammenfasst. Du kannst Kategorien durchsuchen, Produkte vergleichen und direkt zu den Verkaufsseiten navigieren. Das OOPBUY Spreadsheet vereinfacht diesen Prozess erheblich.',
  },
  {
    question: 'Ist OOPBUY sicher?',
    answer: 'Ja, OOPBUY selbst ist eine seri\u00f6se Plattform. Die Sicherheit h\u00e4ngt jedoch auch von den einzelnen Verk\u00e4ufern ab. Das OOPBUY Spreadsheet hilft dir, gepr\u00fcfte Verk\u00e4ufer zu identifizieren und Risiken zu minimieren. Wir empfehlen, immer Bewertungen zu pr\u00fcfen und QC-Bilder anzufordern.',
  },
  {
    question: 'Wie finde ich Produkte mit dem OOPBUY Spreadsheet?',
    answer: 'Das OOPBUY Spreadsheet ist in 14 Kategorien unterteilt \u2013 von Shoes \u00fcber Hoodies bis zu Accessoires. Du kannst entweder die Kategorien durchsuchen oder die integrierte Filterfunktion nutzen, um gezielt nach bestimmten Produkten zu suchen.',
  },
  {
    question: 'Kann ich OOPBUY als Anf\u00e4nger nutzen?',
    answer: 'Absolut! Das OOPBUY Spreadsheet ist besonders f\u00fcr Anf\u00e4nger konzipiert. Es bietet Schritt-f\u00fcr-Schritt-Anleitungen, deutsche Erkl\u00e4rungen und eine intuitive Struktur, die den Einstieg erleichtert. Lies unseren kompletten Anf\u00e4nger-Guide f\u00fcr detaillierte Informationen.',
  },
  {
    question: 'Welche Kategorien gibt es im OOPBUY Spreadsheet?',
    answer: 'Das OOPBUY Spreadsheet 2026 umfasst 14 Hauptkategorien: Shoes, Hoodies/Sweaters, T-Shirts, Jackets, Pants/Shorts, Headwear, Sets, Underwear/Underpants, Jersey, Accessories, Bags, Belts, Perfumes und Other Stuff. Jede Kategorie wird regelm\u00e4\u00dfig aktualisiert.',
  },
  {
    question: 'Wie aktuell ist das OOPBUY Spreadsheet 2026?',
    answer: 'Das OOPBUY Spreadsheet 2026 wird kontinuierlich von unserem Team aktualisiert. Neue Produkte werden t\u00e4glich hinzugef\u00fcgt, veraltete Eintr\u00e4ge entfernt und Preise sowie Verf\u00fcgbarkeiten regelm\u00e4\u00dfig \u00fcberpr\u00fcft. Stand: Juli 2026.',
  },
  {
    question: 'Gibt es das OOPBUY Spreadsheet auf Deutsch?',
    answer: 'Ja, das oopbuy spreadsheet deutsch ist vollst\u00e4ndig auf Deutsch verf\u00fcgbar. Alle Kategorien, Erkl\u00e4rungen und Anleitungen sind in deutscher Sprache verfasst, sodass du keine Sprachbarrieren \u00fcberwinden musst.',
  },
  {
    question: 'Was kostet das OOPBUY Spreadsheet?',
    answer: 'Der Zugang zum OOPBUY Spreadsheet selbst ist kostenlos. Die tats\u00e4chlichen Kosten entstehen nur beim Kauf der Produkte. Die Preisinformationen im Spreadsheet helfen dir, Angebote zu vergleichen und das beste Preis-Leistungs-Verh\u00e4ltnis zu finden.',
  },
  {
    question: 'Wie unterscheidet sich OOPBUY von anderen Plattformen?',
    answer: 'OOPBUY zeichnet sich durch seine umfassende Produktdatenbank und die strukturierte Aufbereitung aus. Das OOPBUY Spreadsheet bietet einen \u00dcberblick, den du auf anderen Plattformen so nicht findest \u2013 mit direktem Preisvergleich, Verk\u00e4uferbewertungen und Kategorie-Filtern.',
  },
  {
    question: 'Kann ich Produkte direkt \u00fcber das Spreadsheet kaufen?',
    answer: 'Das Spreadsheet dient als Informations- und Vergleichstool. Der eigentliche Kauf erfolgt \u00fcber die verlinkten Verkaufsseiten. Das OOPBUY Spreadsheet leitet dich mit direkten Links zu den entsprechenden Produktseiten weiter.',
  },
  {
    question: 'Welche Zahlungsmethoden werden akzeptiert?',
    answer: 'Die verf\u00fcgbaren Zahlungsmethoden h\u00e4ngen von den jeweiligen Verkaufsplattformen ab. \u00dcblich sind Kreditkarte, PayPal, Bank\u00fcberweisung und verschiedene lokale Zahlungsoptionen. Pr\u00fcfe die Zahlungsbedingungen vor dem Kauf.',
  },
  {
    question: 'Wie lange dauert der Versand?',
    answer: 'Die Versanddauer variiert je nach Verk\u00e4ufer und Zielland. In der Regel betr\u00e4gt die Lieferzeit nach Deutschland zwischen 7 und 21 Tagen. Das OOPBUY Spreadsheet enth\u00e4lt oft Hinweise zu gesch\u00e4tzten Versandzeiten.',
  },
  {
    question: 'Was mache ich bei Problemen mit einer Bestellung?',
    answer: 'Bei Problemen mit einer Bestellung solltest du dich zun\u00e4chst direkt an den Verk\u00e4ufer wenden. Dokumentiere alle Kommunikation und bewahre Belege auf. Die meisten Plattformen bieten K\u00e4uferschutz-Programme an.',
  },
  {
    question: 'Gibt es eine OOPBUY App?',
    answer: 'Ja, OOPBUY bietet eine mobile App f\u00fcr iOS und Android an. Das OOPBUY Spreadsheet ist jedoch als webbasierte L\u00f6sung konzipiert und kann auf allen Ger\u00e4ten \u00fcber den Browser aufgerufen werden.',
  },
  {
    question: 'Wie oft wird die OOPBUY Liste aktualisiert?',
    answer: 'Die OOPBUY Liste wird mehrmals w\u00f6chentlich aktualisiert. Unser Team \u00fcberpr\u00fcft t\u00e4glich neue Produkte, entfernt ausverkaufte Artikel und aktualisiert Preisinformationen, um dir stets die aktuellsten Daten zu liefern.',
  },
  {
    question: 'Kann ich eigene Produkte zum Spreadsheet hinzuf\u00fcgen?',
    answer: 'Das OOPBUY Spreadsheet wird zentral von unserem Team gepflegt. Wenn du ein interessantes Produkt entdeckt hast, kannst du es \u00fcber unser Kontaktformular vorschlagen. Wir pr\u00fcfen jede Einsendung sorgf\u00e4ltig.',
  },
  {
    question: 'Was bedeuten die Bewertungen im Spreadsheet?',
    answer: 'Die Bewertungen basieren auf einer Kombination aus Verk\u00e4ufer-Ratings, Produktqualit\u00e4t und Nutzerfeedback. Sie helfen dir, vertrauensw\u00fcrdige Verk\u00e4ufer und hochwertige Produkte auf einen Blick zu identifizieren.',
  },
  {
    question: 'Gibt es Garantie oder R\u00fcckgaberecht?',
    answer: 'Garantie- und R\u00fcckgabebedingungen h\u00e4ngen vom jeweiligen Verk\u00e4ufer ab. Das OOPBUY Spreadsheet kennzeichnet Verk\u00e4ufer mit k\u00e4uferfreundlichen R\u00fcckgaberichtlinien. Informiere dich vor dem Kauf \u00fcber die spezifischen Bedingungen.',
  },
  {
    question: 'Wie starte ich am besten mit OOPBUY?',
    answer: 'Der beste Einstieg ist unser <a href="/artikel/oopbuy-spreadsheet-guide" class="text-primary-600 underline hover:text-primary-700">Anf\u00e4nger-Guide</a>. Dort findest du eine Schritt-f\u00fcr-Schritt-Anleitung, wie du das OOPBUY Spreadsheet optimal nutzt. Beginne mit einer Kategorie deiner Wahl und erkunde die verf\u00fcgbaren Produkte.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-16 md:py-20">
      <div className="container-custom">
        {/* Header */}
        <div className="mb-12">
          <p className="text-xs font-semibold text-primary-600 uppercase tracking-wider mb-3">FAQ &amp; Hilfe</p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
            H&auml;ufig gestellte Fragen zum<br />OOPBUY Spreadsheet
          </h2>
        </div>

        {/* Testimonial Badge */}
        <div className="mb-8">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-foreground-900 text-background-50 rounded-full">
            <span className="w-4 h-4 flex items-center justify-center text-accent-400">
              <i className="ri-star-fill text-xs"></i>
            </span>
            <span className="text-sm font-semibold">4.9/5.0</span>
          </div>
        </div>

        {/* Testimonial Quote */}
        <div className="max-w-2xl mb-10">
          <blockquote className="font-heading text-xl md:text-2xl text-foreground-800 leading-relaxed italic">
            &ldquo;Das OOPBUY Spreadsheet hat meine Einkaufsweise komplett ver&auml;ndert. Ich finde Produkte dreimal schneller und habe endlich den &Uuml;berblick, den ich vorher nie hatte.&rdquo;
          </blockquote>
          <div className="flex items-center gap-3 mt-4">
            <div className="w-10 h-10 rounded-full bg-background-200 overflow-hidden flex items-center justify-center">
              <i className="ri-user-line text-foreground-500"></i>
            </div>
            <div>
              <p className="text-sm font-semibold text-foreground-900">Markus K.</p>
              <p className="text-xs text-foreground-500">OOPBUY Nutzer seit 2025</p>
            </div>
          </div>
        </div>

        {/* FAQ Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-50 transition-colors"
              >
                <span className="text-sm font-medium text-foreground-800">{faq.question}</span>
                <span className={`w-5 h-5 flex-shrink-0 flex items-center justify-center transition-transform duration-200 ${
                  openIndex === index ? 'rotate-45' : ''
                }`}>
                  <i className="ri-add-line text-foreground-500"></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p
                    className="text-sm text-foreground-600 leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: faq.answer }}
                  ></p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA after FAQ */}
        <div className="mt-12 text-center">
          <Link
            to="/artikel/oopbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 bg-accent-100 text-accent-700 rounded-full text-sm font-semibold hover:bg-accent-200 transition-colors whitespace-nowrap cursor-pointer"
          >
            Zum vollst&auml;ndigen Guide
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}